import React from "react";
import { Box, Button, Container, Typography, Grid } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
const logoSrc = `${process.env.PUBLIC_URL}/assets/images/home.jpg`;

const HeroSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        py: { xs: 8, md: 12 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.1,
          backgroundImage:
            "radial-gradient(circle, #ffffff 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />

      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Box sx={{ maxWidth: 600 }}>
              <Typography
                variant="h1"
                component="h1"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  fontSize: { xs: "2.5rem", md: "3.5rem" },
                  fontFamily: "'Playfair Display', serif", // Apply custom font
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                }}
              >
                ProtoDiag - Empowering the Future of Telecom Communication
              </Typography>

              <Typography
                variant="h5"
                component="p"
                sx={{
                  mb: 4,
                  fontWeight: 400,
                  opacity: 0.9,
                  fontFamily: "'Roboto', sans-serif", // Regular sans-serif font for subheading
                }}
              >
                Next-generation communication infrastructure for enterprises and
                mobile network operators. Leading telecom solutions provider in Noida, India.
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  component={RouterLink}
                  to="/products"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: "1rem",
                    fontWeight: 600,
                    fontFamily: "'Roboto', sans-serif", // Button font
                  }}
                >
                  Explore Solutions
                </Button>

                <Button
                  variant="outlined"
                  color="inherit"
                  size="large"
                  component={RouterLink}
                  to="/contact"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: "1rem",
                    fontWeight: 600,
                    borderColor: "white",
                    fontFamily: "'Roboto', sans-serif", // Button font
                    "&:hover": {
                      borderColor: "white",
                      backgroundColor: "rgba(255,255,255,0.1)",
                    },
                  }}
                >
                  Contact Us
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={5}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <Box
              sx={{
                position: "relative",
                height: 400,
                width: "100%",
                backgroundColor: "rgba(255,255,255,0.1)",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
            >
              <img 
                src={logoSrc} 
                alt="ProtoDiag Solutions - Enterprise Telecom Communication Infrastructure" 
                title="ProtoDiag Solutions Telecom Platform"
              />
              {/* Placeholder for hero image */}
              <Typography variant="h3" color="white" sx={{ opacity: 0.7 }}>
                Next-Gen Communication
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
